__turbopack_context__.v({
  "className": "_1yr7nq_className",
  "variable": "_1yr7nq_variable",
});
